import { createSelector } from 'reselect';

/**
 * Direct selector to the resources state domain
 */

const selectListsDomain = state => state.editorLists;

/**
 * Other specific selectors
 */

/**
 * Default selector used by Resources
 */

const makeSelectProcessing = () =>
  createSelector(
    selectListsDomain,
    substate => substate.processing,
  );
const makeSelectCreateListResult = () =>
  createSelector(
    selectListsDomain,
    substate => substate.listResult,
  );
const makeSelectLists = () =>
  createSelector(
    selectListsDomain,
    substate => substate.lists,
  );
const makeSelectDeleteListResult = () =>
  createSelector(
    selectListsDomain,
    substate => substate.deleteListResult,
  );
const makeSelectRenameListResult = () =>
  createSelector(
    selectListsDomain,
    substate => substate.renameListResult,
  );

export {
  makeSelectProcessing,
  makeSelectCreateListResult,
  makeSelectLists,
  makeSelectDeleteListResult,
  makeSelectRenameListResult,
};
